import { render, staticRenderFns } from "./ImageTagArea.vue?vue&type=template&id=53bc00ec&scoped=true&"
import script from "./ImageTagArea.vue?vue&type=script&lang=js&"
export * from "./ImageTagArea.vue?vue&type=script&lang=js&"
import style0 from "./ImageTagArea.vue?vue&type=style&index=0&id=53bc00ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc00ec",
  null
  
)

export default component.exports